import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { Space, Modal, DotLoading, AutoCenter } from 'antd-mobile';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import secureStorage from '../../../shared/secureStorage';

const SelectType = () => {
  const navigate = useNavigate();
  const httpHandler = new WebviewHttpHandler(true);

  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(true); // 控制Modal显示

  const handleIndividualClick = () => {
    navigate('/m/Bind/Individual');
  };

  const handleCorporateClick = () => {
    navigate('/m/Bind/Corporate');
  };

  const goToSurvey = () => {
    // 导航到问卷填写页面
    navigate('/m/PreferenceQuestionnaire');
  };

  const stayHere = () => {
    setIsModalVisible(false); // 关闭Modal
  };

  const checkSurveyExist = () => {
    // 若使用者尚未填寫問卷，則跳出提示窗
    setIsLoading(true);
    const lineUserId = secureStorage.getItem('lineUserId');
    httpHandler
      .get(`/webview/check_survey_exist?line_user_id=${lineUserId}`)
      .then((response) => {
        if (response.success) {
          const isExist = response.data.is_exist === 1;
          setIsModalVisible(!isExist);
        } else {
          console.log(response.data);
          setIsModalVisible(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsModalVisible(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    checkSurveyExist();
  }, []);

  return (
    <div className="main-container">
      {isLoading ? (
        <AutoCenter>
          載入中
          <DotLoading />
        </AutoCenter>
      ) : (
        <>
          <Modal
            content={
              <div className="goto-survey-modal-content">
                填寫用車喜好問卷
                <br />
                為您提供更完善的租車方案
              </div>
            }
            visible={isModalVisible}
            onConfirm={stayHere}
            onClose={stayHere}
            closeOnAction
            actions={[
              {
                text: '前往填寫',
                key: 'survey',
                onClick: goToSurvey,
                className: 'secondary-button',
              },
              // {
              //   text: '下次再說',
              //   key: 'stay',
              //   onClick: stayHere,
              //   className: 'empty-button',
              // },
            ]}></Modal>
          <Space block direction="vertical" style={{ '--gap': '16px' }}>
            <div className="text-align-center">
              <div className="heading font-bold pd-1">會員綁定</div>
              <div className="text-body font-normal">請選擇您的承租身份</div>
            </div>
            <div className="card-container" onClick={handleIndividualClick}>
              <img
                src="/images/illustration/individual.svg"
                alt="Description"
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className="text-body font-semibold"
                  style={{ marginRight: '8px' }}>
                  個人用
                </div>
                <RightOutlined style={{ color: '#A7A9AC' }} />
              </div>
            </div>
            <div className="card-container" onClick={handleCorporateClick}>
              <img src="/images/illustration/corporate.svg" alt="Description" />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className="text-body font-semibold"
                  style={{ marginRight: '8px' }}>
                  企業用
                </div>
                <RightOutlined style={{ color: '#A7A9AC' }} />
              </div>
            </div>
          </Space>
        </>
      )}
    </div>
  );
};

export default SelectType;
